import React from "react"

const Header = () => {
  return (
    <header>
      <h1>todos</h1>
    </header>
  )
}

export default Header
